import React from 'react';
import OrderListItem, { OrderListItemProps } from './OrderListItem';
import { NoResultsCard } from '@/components/Cards';
import { Trans } from '@lingui/react/macro';
import { Order } from '@/types';

type OrderListProps = Omit<OrderListItemProps, 'order' | 'defaultExpanded'> & {
    orders: Order[];
    defaultExpandedId?: number;
};

const OrderList: React.FC<OrderListProps> = ({ orders, defaultExpandedId, ...rest }) => {
    return (
        <>
            {orders.map((order) => (
                <OrderListItem defaultExpanded={order.id === defaultExpandedId} key={order.id} order={order} {...rest} />
            ))}

            {orders.length === 0 && (
                <NoResultsCard>
                    <Trans>No orders</Trans>
                </NoResultsCard>
            )}
        </>
    );
};

export default OrderList;